import { useEffect } from 'react'
import { isPageModalOpen } from '@/features/ai-chat/pageModal'

/**
 * 页面有模态对话框时，在这个元素上拦住这些事件的冒泡：挡住 Radix 的「点外面就关」（document 上的
 * pointerdown 监听）与滚动锁（wheel / touch），§9.1 ④ 实测变体 B。
 *
 * 浮窗与最小化小条都要挂：两者都在 z-[90] 且 pointer-events:auto，压在页面遮罩之上（review 09-13）。
 *
 * ⚠️ 约束：元素 portal 在 body 下，React 的事件监听在 body 上，这里 stopPropagation 之后
 * **浮窗内的 onPointerDown / onMouseDown / onWheel / onTouchStart 在只读期间收不到**（onClick 不受影响）。
 * 目前只读期间的交互只剩标题栏按钮（onClick）；以后在浮窗里加靠 onPointerDown 开合的控件要记得这一点。
 * 不拦 focusin：Radix 把焦点拉回对话框走的是对话框自己的 focusout，拦了没用，反而挡掉 React 的 onFocus。
 */
const ISOLATED_EVENTS = ['pointerdown', 'mousedown', 'wheel', 'touchstart', 'touchmove'] as const

export function useIsolateWhilePageModal(el: HTMLElement | null, windowEl: () => HTMLElement | null = () => el) {
  useEffect(() => {
    if (!el) return
    // 在事件发生那一刻重判：MutationObserver 回调是异步的，不能只信 state
    const stop = (e: Event) => { if (isPageModalOpen(windowEl())) e.stopPropagation() }
    for (const type of ISOLATED_EVENTS) el.addEventListener(type, stop)
    return () => { for (const type of ISOLATED_EVENTS) el.removeEventListener(type, stop) }
  }, [el, windowEl])
}
